import React from 'react';
import CenteredLayout from 'layouts/CenteredLayout';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

function Expired() {
  const { t } = useTranslation('expired');
  return (
    <CenteredLayout>
      <h2 className={styles.title}>{t('sessionExpiredTitle')}</h2>
      <p className={styles.body}>{t('sessionExpiredBody')}</p>
    </CenteredLayout>
  );
}

export default Expired;
